/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_Li4Inputs */

const tr_servis_s2_li4 = /** @type {(inputs: Servis_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VUK 213 uyarınca faturalar 10 yıl boyunca saklanır.`)
};

const en_servis_s2_li4 = /** @type {(inputs: Servis_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to VUK 213, invoices are retained for 10 years.`)
};

const de_servis_s2_li4 = /** @type {(inputs: Servis_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß VUK 213 werden Rechnungen 10 Jahre lang aufbewahrt.`)
};

const ru_servis_s2_li4 = /** @type {(inputs: Servis_S2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В соответствии с VUK 213 счета хранятся 10 лет.`)
};

/**
* | output |
* | --- |
* | "Pursuant to VUK 213, invoices are retained for 10 years." |
*
* @param {Servis_S2_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_li4 = /** @type {((inputs?: Servis_S2_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_li4(inputs)
	if (locale === "de") return de_servis_s2_li4(inputs)
	if (locale === "ru") return ru_servis_s2_li4(inputs)
	return tr_servis_s2_li4(inputs)
});